export default (errMsg = 'Failed to fetch!', query, variables) => {
    // return fetch('https://triniti.eu/graphql', {
    return fetch('https://triniti.wam1.lt/graphql', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({query, variables}),
    }).then(response => {
        if (!response.ok) throw new Error(errMsg);
        return response.json();
    });
}